export const DISCOUNT_TYPES = Object.freeze({ AMOUNT: 'amount', PERCENT: 'percent' });
export const EXPERIMENTS = Object.freeze({ OFF: 'off', ON: 'on' });
export const PRODUCTS = Object.freeze({ CUSTOM: 'custom', STANDARD: 'standard' });
